module.exports = __webpack_public_path__ + "static/media/mission.b02a540f.png";